var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-4247b421-f2d2-48c6-bb81-a55c85cbf09d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 1.244c0-.334-.13-.648-.366-.884-.473-.472-1.295-.472-1.768 0L10 8.226 2.134.36C1.66-.112.839-.112.366.36.13.596 0 .91 0 1.244c0 .334.13.648.366.884l7.866 7.866L.366 17.86c-.236.236-.366.55-.366.884 0 .334.13.648.366.884.473.472 1.295.472 1.768 0L10 11.762l7.866 7.866c.236.236.55.366.884.366.334 0 .647-.13.884-.366a1.24 1.24 0 0 0 .366-.884c0-.334-.13-.648-.366-.884l-7.867-7.866 7.867-7.866c.236-.236.366-.55.366-.884z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.7014e9f3965854bce696b889b48c9acb.svg";
export { ForwardRef as ReactComponent };